enum TextSymbol {
  Infinity = "∞",
  SolSymbol = "◎",
}

export default TextSymbol;
